import React from "react";

const Img = ({ dark }) => {
  return (
    <img
      src={
        dark
          ? "https://statics.teams.cdn.office.net/evergreen-assets/apps/2e3a628d-6f54-4100-9e7a-f00bc3621a85_small_VivaLearning.png?v=1.0.0"
          : "https://statics.teams.cdn.office.net/evergreen-assets/apps/2e3a628d-6f54-4100-9e7a-f00bc3621a85_small_VivaLearning.png?v=1.0.0"
      }
      alt="img"
      style={{ width: 16, height: 16 }}
    />
  );
};

export default Img;
